import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';

import { useCourseMediaItems } from 'modules/media/hooks';

import { useImportSubjectItemsFromCourse } from 'modules/subjects/components/ImportSubjectItemsFromCourse';

export default function useImportDocumentsFromCourse({ courseId, onConfirmSelection, importingMediaItems }) {
  const intl = useIntl();
  const [selectedCourseId, setSelectedCourseId] = useState();

  const { mediaItems, loading } = useCourseMediaItems({
    courseId: selectedCourseId,
  });

  const { selectedCourse, courseSelectorProps, subjectItemsSelectorProps } = useImportSubjectItemsFromCourse({
    courseId,
    items: mediaItems,
    loading,
    submitting: importingMediaItems,
    title: intl.formatMessage({
      id: 'dialog.importVideos.availableVideos',
    }),
    confirmButtonTitle: intl.formatMessage({
      id: 'dialog.importVideos.title',
    }),
    onConfirmSelection,
  });

  useEffect(() => {
    if (!selectedCourse?._id) return;
    setSelectedCourseId(selectedCourse?._id);
  }, [selectedCourse]);

  return {
    courseSelectorProps,
    subjectItemsSelectorProps,
  };
}
